"use strict";

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

require("jquery-validation");

require("magnific-popup");

var _cookies = require("./cookies");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/* eslint-disable indent-legacy */
/* eslint-disable no-tabs */
/* eslint-disable no-useless-escape */
var checkSubscribeStatus = (0, _cookies.getCookie)("subscribe-hidden");

// mailchimp subscribe form
(0, _jquery2.default)(document).on("submit", ".js-subscribe-ajax", function (event) {
  event.preventDefault();

  var self = this;
  var $form = (0, _jquery2.default)(this);
  var radioButtons = this.querySelectorAll('[name="gender"]');
  var formAction = $form.attr("action");
  var radioVal = "";

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = radioButtons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var button = _step.value;

      if (button.checked) {
        radioVal = button.value;
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  (0, _jquery2.default)(this).validate({
    rules: {
      EMAIL: "required",
      "BIRTHDAY-month": "required",
      "BIRTHDAY-day": "required",
      "BIRTHDAY-year": "required"
    },
    messages: {
      EMAIL: "Please enter a valid email address",
      "BIRTHDAY-year": {
        required: "Required",
        max: "Must be {0} or lower",
        min: "Must be {0} or higher"
      },
      "BIRTHDAY-month": {
        required: "Required",
        max: "Must be {0} or lower",
        min: "Must be 0{0} or higher"
      },
      "BIRTHDAY-day": {
        required: "Required",
        max: "Must be {0} or lower",
        min: "Must be 0{0} or higher"
      }
    }
  });

  if ((0, _jquery2.default)(this).valid()) {
    var email = this.querySelector('[name="email"]').value;
    var dob_month = this.querySelector('[name="BIRTHDAY-month"]').value;
    var dob_day = this.querySelector('[name="BIRTHDAY-day"]').value;
    var dob_year = this.querySelector('[name="BIRTHDAY-year"]').value;
    var gender = radioVal;
    var message = "YOU'RE IN!<br/>EXCITING THINGS IN YOUR INBOX SOON.";
    var data = {
      list_id: "newsletter",
      email: email,
      gender: gender,
      dob_month: dob_month,
      dob_day: dob_day,
      dob_year: dob_year
    };

    zaius.subscribe(data);

    $form.find(".form__message").attr("class", "form__message form__message--success").html(message).fadeIn().css("display", "inline-block");

    $form.find(".form__body").hide();

    (0, _cookies.setCookie)("subscribe-hidden", true);
  }
  //    else if (radioVal === "") {
  //     const column = self.querySelector(".form__radios");
  //     const markup =
  //       '<label id="mce-GENDER-error" class="error" for="mce-GENDER">Please select</label>';
  //     column.insertAdjacentHTML("afterend", markup);
  //   }
});

if (!checkSubscribeStatus) {
  setTimeout(function () {
    _jquery2.default.magnificPopup.open({
      items: {
        src: (0, _jquery2.default)("#popup-newsletter")
      },
      type: "inline",
      fixedBgPos: false,
      fixedContentPos: false,
      mainClass: "mfp-newsletter",
      callbacks: {
        close: function close() {
          (0, _cookies.setCookie)("subscribe-hidden", true);
        }
      }
    });

    // move close button inside popup newsletter
    (0, _jquery2.default)(".mfp-close").appendTo(".popup-newsletter");

    (0, _jquery2.default)(window).on("scroll", function () {
      var footerHeight = (0, _jquery2.default)(".footer").outerHeight();
      var scrollHeight = (0, _jquery2.default)(document).height() - footerHeight;
      var scrollPosition = (0, _jquery2.default)(window).height() + (0, _jquery2.default)(window).scrollTop();
      if (scrollPosition > scrollHeight) {
        (0, _jquery2.default)(".mfp-wrap").fadeOut();
      } else {
        (0, _jquery2.default)(".mfp-wrap").fadeIn();
      }
    });
  }, 1000);
}